import React from "react";
import SEO from "../components/SEO";
import "./Privacypolicy.css";

const Privacypolicy = () => {
  return (
    <div className="privacy-container">
      <SEO
        title="Privacy Policy — D Base Solutions Pvt Ltd"
        description="Official Privacy Policy and data protection terms for D Base Solutions Pvt Ltd enterprise and mobile applications."
        keywords="D Base Solutions privacy policy, DBS data protection, privacy terms"
        canonical="https://dbasesolutions.in/privacy-policy"
        ogImage="/og-image.png"
        breadcrumbs={[
          { name: "Home", url: "/" },
          { name: "Privacy Policy", url: "/privacy-policy" }
        ]}
      />
      <div className="privacy-card">
        <h1>Privacy Policy</h1>

      

        <h2>1. Introduction</h2>
        <p>
          Welcome to <strong>DBS OFFICE</strong>. We are
          committed to protecting your personal information and your right to
          privacy. This Privacy Policy explains how we collect, use, disclose,
          and safeguard your information when you use the DBS OFFICE mobile
          application (the "App"). The App is designed as an internal enterprise
          management and productivity tool for employees and authorized
          personnel.
        </p>

        <p>
          By using the App, you agree to the collection and use of information
          in accordance with this Privacy Policy. If you do not agree with the
          terms of this Privacy Policy, please do not access the App.
        </p>

        <h2>2. Information We Collect</h2>

        <p>
          We collect personal and technical information necessary to provide and
          manage our enterprise services effectively.
        </p>

        <h3>A. Personal Information You Provide to Us</h3>

        <p>When you register, log in, or use the App, we may collect:</p>

        <ul>
          <li>
            <strong>Profile Data:</strong> Name, employee ID, email address,
            phone number, job title, and profile picture.
          </li>

          <li>
            <strong>Employment Data:</strong> Salary details, timesheets, leave
            requests, work reports, overtime records, and task assignments.
          </li>

          <li>
            <strong>Financial Data:</strong> Information related to expenses,
            invoices, and transactions you submit through the App.
          </li>
        </ul>

        <h3>B. Biometric and Facial Data (AI Attendance)</h3>

        <p>
          To utilize the AI Attendance features, the App requires access to your
          device's camera to capture your facial image for identity verification
          and registration. This data is strictly used for secure and automated
          attendance tracking.
        </p>

        <h3>C. Device and Permission-Based Information</h3>

        <p>
          Depending on your device settings and app usage, we may request and
          collect the following:
        </p>

        <ul>
          <li>
            <strong>Location Data (Geolocation):</strong> We collect coarse and
            fine location data (with your permission) to verify on-duty status,
            track work-related travel, and ensure accurate attendance logging.
          </li>

          <li>
            <strong>Camera and Photos:</strong> With your permission, we access
            your camera and photo gallery to allow you to upload profile
            pictures, scan barcodes/QR codes, submit document images for leave
            requests or tickets, and use the AI Attendance feature.
          </li>

          <li>
            <strong>Storage Access:</strong> We require read/write access to
            your device's external storage to save downloaded reports (e.g.
            PDFs, Excel files) and to upload local files.
          </li>
        </ul>

        <h2>3. How We Use Your Information</h2>

        <p>
          We use the collected information for various business and
          employment-related purposes, including:
        </p>

        <ul>
          <li>
            <strong>Account Management:</strong> To create, authenticate, and
            manage your employee profile.
          </li>

          <li>
            <strong>Attendance and Tracking:</strong> To monitor attendance
            using AI facial recognition and verify location during on-duty
            hours.
          </li>

          <li>
            <strong>Operational Productivity:</strong> To manage tasks, tickets,
            work reports, and equipment assignments.
          </li>

          <li>
            <strong>HR and Payroll:</strong> To process leave requests, track
            overtime, manage salaries, and handle employee requests.
          </li>

          <li>
            <strong>Communication:</strong> To send administrative information,
            updates, and notifications regarding your tasks or HR policies.
          </li>

          <li>
            <strong>App Improvement:</strong> To analyze usage trends, fix bugs,
            and improve the overall user experience.
          </li>
        </ul>

        <h2>4. How We Share Your Information</h2>

        <p>
          We do not sell, rent, or trade your personal information. We may
          share your data in the following limited circumstances:
        </p>

        <ul>
          <li>
            <strong>Internal Access:</strong> Authorized company
            administrators, HR personnel, and managers will have access to your
            data to perform their job duties.
          </li>

          <li>
            <strong>Service Providers:</strong> We may share data with trusted
            third-party vendors who assist us in operating the App, processing
            payroll, or hosting our servers (e.g., cloud hosting providers).
          </li>

          <li>
            <strong>Legal Compliance:</strong> We may disclose your information
            if required by law, subpoena, or other legal processes, or to
            protect the rights, property, or safety of the company, our
            employees, or others.
          </li>
        </ul>

        <h2>5. Data Security</h2>

        <p>
          We implement robust administrative, technical, and physical security
          measures to protect your personal information. This includes secure
          server environments, encrypted communications, and restricted access
          protocols. However, no electronic transmission over the internet or
          information storage technology can be guaranteed to be 100% secure, so
          we cannot promise or guarantee that hackers, cybercriminals, or other
          unauthorized third parties will not be able to defeat our security.
        </p>

        <h2>6. Your Rights and Choices</h2>

        <ul>
          <li>
            <strong>Account Settings:</strong> You can review or update certain
            profile information within the App settings. For core HR data, you
            must contact your administrator.
          </li>

          <li>
            <strong>Device Permissions:</strong> You can enable or disable
            location tracking, camera access, and storage permissions at any
            time through your device's settings. Please note that disabling
            these permissions may severely limit your ability to use core
            features of the App (such as attendance logging).
          </li>

          <li>
            <strong>Data Deletion:</strong> If your employment or contract is
            terminated, your account and associated data will be managed
            according to our internal data retention policies and applicable
            laws.
          </li>
        </ul>

        <h2>7. Children's Privacy</h2>

        <p>
          The App is intended solely for adult employees and authorized
          personnel of the company. We do not knowingly solicit or collect
          information from children under the age of 13 (or higher age threshold
          depending on the jurisdiction).
        </p>

        <h2>8. Changes to This Privacy Policy</h2>

        <p>
          We may update this Privacy Policy from time to time to reflect changes
          in our practices, technology, or legal requirements. We will notify
          you of any significant changes by posting the new Privacy Policy
          within the App or via email. You are advised to review this Privacy
          Policy periodically.
        </p>

        <h2>9. Contact Us</h2>

        <p>
          If you have questions or comments about this Privacy Policy or our
          data practices, please contact us at:
        </p>

        <p>
          <strong>DBase Solution Pvt.Ltd</strong>
        </p>

        <p>Email: hr@dbasesolutions.in</p>

        <p>Address: D.No: 16-58/33, Sai Sadan, Hanuman Nagar, Eluru, AP-534001, India</p>

        <p>Phone: +91 93943 22302</p>
      </div>
    </div>
  );
};

export default Privacypolicy;